import React from 'react';
import { PropTypes } from 'prop-types';
import { Box } from '@mui/material';

const ListContainer = props => {
    const { children } = props;

    return (
        <Box
            sx={theme => ({
                padding: '60px 20px 34px',
                width: '100%',
                display: 'flex',
                flexDirection: 'column',
                height: `calc(100% - ${theme.constants.footerHeight}px)`,
            })}
        >
            {children}
        </Box>
    );
};

ListContainer.propTypes = {
    children: PropTypes.node.isRequired,
};

export default ListContainer;
